module.exports = __webpack_public_path__ + "static/img/7.5b5ccb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shen/7.png
// module id = u4aD
// module chunks = 0